<template>
  <div>
    <section id="menu-k" data-rv-view="0" v-if="data">

      <nav class="navbar navbar-dropdown transparent navbar-fixed-top bg-color">
        <div class="container">

          <div class="mbr-table">
            <div class="mbr-table-cell">

              <div class="navbar-brand">
                <a href="/" class="navbar-logo"><img
                    :src="data.logo" alt="brmill"></a>
              </div>

            </div>
            <div class="mbr-table-cell">

              <button class="navbar-toggler pull-xs-right hidden-md-up" type="button"
                      data-toggle="collapse" data-target="#exCollapsingNavbar">
                <div class="hamburger-icon"></div>
              </button>

              <ul class="nav-dropdown collapse pull-xs-right nav navbar-nav navbar-toggleable-sm"
                  id="exCollapsingNavbar">
                <li class="nav-item dropdown"><a class="nav-link link dropdown-toggle" href="//"
                                                 data-toggle="dropdown-submenu"
                                                 aria-expanded="false">{{ data.menu1.menu }}</a>
                  <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/#history">{{ data.menu1.submenu1 }}</router-link>
                    <router-link class="dropdown-item" to="/#values">{{ data.menu1.submenu2 }}
                    </router-link>
                    <router-link class="dropdown-item" to="/codeEthics">{{ data.menu1.submenu3 }}
                    </router-link>
                    <router-link class="dropdown-item" to="/companyPolicies">{{ data.menu1.submenu4 }}
                    </router-link>
                  </div>
                </li>
                <li class="nav-item dropdown">

                  <a class="nav-link link dropdown-toggle"
                     data-toggle="dropdown-submenu" href="//"
                     aria-expanded="false">{{ data.menu2.menu }}</a>
                  <div class="dropdown-menu">
                    <router-link class="dropdown-item" to="/commitment">{{ data.menu2.submenu1 }}
                    </router-link>
                    <router-link class="dropdown-item" to="/certifications">{{ data.menu2.submenu2 }}
                    </router-link>
                  </div>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link link" to="/products">{{ data.menu3.menu }}</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link link" to="/exportation">{{ data.menu4.menu }}</router-link>
                </li>
                <li class="nav-item">
                  <router-link class="nav-link link" to="/#location">{{ data.menu5.menu }}</router-link>
                </li>
                <li class="nav-item nav-btn">
                  <div @click="setLanguage('pt')" class="nav-link btn btn-white btn-warning-outline"
                       v-bind:class="{'active':(language === 'pt')}">
                    PT
                  </div>
                </li>

                <li class="nav-item nav-btn">
                  <div @click="setLanguage('en')" class="nav-link btn btn-white btn-warning-outline"
                       v-bind:class="{'active':(language === 'en')}">
                    EN
                  </div>
                </li>
                <li class="nav-item nav-btn">
                  <div @click="setLanguage('es')" class="nav-link btn btn-white btn-warning-outline"
                       v-bind:class="{'active':(language === 'es')}">
                    ES
                  </div>
                </li>
                <li class="nav-item nav-btn"><a class="nav-link btn btn-white btn-warning-outline"
                                                href="index.html#contacts2-a">{{ data.menu6.menu }}</a></li>
              </ul>
              <button hidden="" class="navbar-toggler navbar-close" type="button" data-toggle="collapse"
                      data-target="#exCollapsingNavbar">
                <div class="close-icon"></div>
              </button>

            </div>
          </div>

        </div>
      </nav>

    </section>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    msg: String
  },
  data() {
    return {
      language: {},
      data: '',
      pt: {
        logo: 'assets/images/logo-brmill-alimentos-291x128.png',
        menu1: {
          menu: 'A EMPRESA',
          submenu1: 'HISTÓRIA',
          submenu2: 'MISSÃO, VISÃO, VALORES',
          // submenu3: 'CÓDIGO DE ÉTICA E CONDUTA',
          // submenu3: 'POLÍTICAS DA EMPRESA',
        },
        menu2: {
          menu: 'QUALIDADE',
          submenu1: 'COMPROMETIMENTO',
          submenu2: 'CERTIFICAÇÕES',
        },
        menu3: {
          menu: 'PRODUTOS'
        },
        menu4: {
          menu: 'EXPORTAÇÃO'
        },
        menu5: {
          menu: 'LOCALIZAÇÃO',
        },
        menu6: {
          menu: 'CONTATO',
        }
      },
      en: {
        logo: 'assets/images/logo-brmill-foods-231x128.png',
        menu1: {
          menu: 'COMPANY',
          submenu1: 'HISTORY',
          submenu2: 'MISSION, VISION, VALUES',
          // submenu3: 'CODE OF ETHICS AND CONDUCT',
          // submenu3: 'COMPANY POLICIES',
        },
        menu2: {
          menu: 'QUALITY',
          submenu1: 'COMMITMENT',
          submenu2: 'CERTIFICATIONS',
        },
        menu3: {
          menu: 'PRODUCTS'
        },
        menu4: {
          menu: 'EXPORTS',
        },
        menu5: {
          menu: 'LOCATION',
        },
        menu6: {
          menu: 'CONTACT',
        }
      },
      es: {
        logo: 'assets/images/logo-brmill-alimentos-291x128.png',
        menu1: {
          menu: 'LA EMPRESA',
          submenu1: 'HISTORIA',
          submenu2: 'MISIÓN VISIÓN VALORES',
          // submenu3: 'CÓDIGO DE ÉTICA Y CONDUCTA',
          // submenu4: 'COMPAÑÍA DE POLICÍAS',
        },
        menu2: {
          menu: 'CALIDAD',
          submenu1: 'COMPROMISO',
          submenu2: 'CERTIFICACIONES',
        },
        menu3: {
          menu: 'PRODUCTOS'
        },
        menu4: {
          menu: 'EXPORTACIONES',
        },
        menu5: {
          menu: 'UBICACIÓN',
        },
        menu6: {
          menu: 'CONTACTO',
        }
      }
    }
  },
  methods: {
    setLanguage: function (value) {
      this.language = value
      localStorage.setItem('language', value)
      document.location.reload(true);
    }

  },
  mounted() {
    if (localStorage.language) {
      this.language = localStorage.language;
    } else {
      localStorage.setItem('language', 'pt')
      document.location.reload(true);
    }
    switch (this.language) {
      case 'en':
        this.data = this.en;
        break;
      case 'es':
        this.data = this.es;
        break;
      default:
        this.data = this.pt;
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media (min-width: 992px) {

  .navbar.custom-nav {
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: #fff !important;
  }

}

</style>
